export default __webpack_public_path__ + "static/learn-arduino-412b2db25e4f5b567ef91d9446a62988.png";